<template>
  <div>
    <div
      class="topBar"
      :style="
        topBar == 0 ? 'background:rgba(85, 84, 84, 0.304);' : 'background:#fff'
      "
    >
      <div class="topBar_left">
        <img src="@/statis/imgs/801.png" alt="" v-if="topBar == 0" />
        <img src="@/statis/imgs/802.png" alt="" v-else />
      </div>
      <div class="topBar_right">
        <p
          :style="topBar == 0 ? 'color:#fff;' : 'color:#000;'"
          @mouseover="select(0)"
          @click="toHome"
        >
          首页
        </p>
        <p
          :style="topBar == 0 ? 'color:#fff;' : 'color:#000;'"
          @mouseover="select(1)"
          @click="toExample"
        >
          应用案例
        </p>
        <p
          :style="topBar == 0 ? 'color:#fff;' : 'color:#000;'"
          @mouseover="select(2)"
          @click="toAbout"
        >
          关于我们
        </p>
        <span
          class="transitionBar"
          :style="topBar == 0 ? 'background:#fff;' : 'background:#6D66F1;'"
          ref="transitionBar"
        ></span>
      </div>
    </div>

    <div class="mobileBar">
      <p @click="toHome">
        <img src="@/statis/imgs/802.png" alt="" />
      </p>
      <p @click="openMenus">
        <img
          src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/pub/list.svg"
          alt=""
        />
      </p>
      <ul :style="menus == 1 ? 'height:auto;' : 'height:0'">
        <li @click="toHome">首页</li>
        <li @click="toExample">应用案列</li>
        <li @click="toAbout">关于我们</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topBar: 0,
      menus: 0,
    };
  },
  mounted() {
    console.log("首页");
    let that = this;

    window.onscroll = function () {
      //为了保证兼容性，这里取两个值，哪个有值取哪一个
      //scrollTop就是触发滚轮事件时滚轮的高度
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      if (scrollTop == 0) {
        that.topBar = 0;
      } else {
        that.topBar = 1;
      }
    };
  },
  methods: {
    select(val) {
      switch (val) {
        case 0:
          this.$refs.transitionBar.style.left = val * 100 + 196 + "px";
          break;
        case 1:
          this.$refs.transitionBar.style.left = val * 100 + 200 + "px";
          break;
        case 2:
          this.$refs.transitionBar.style.left = val * 100 + 207 + "px";
          break;
        default:
          break;
      }
    },
    openMenus() {
      this.menus == 1 ? (this.menus = 0) : (this.menus = 1);

      console.log(this.menus);
    },
    toAbout() {
      this.$router.push("/about");
      this.menus = 0;
    },
    toHome() {
      this.$router.push("/");
      this.menus = 0;
    },
    toExample() {
      this.$router.push("/exampleList");
      this.menus = 0;
    },
  },
};
</script>

<style lang="less">
@import url("@/statis/css/base.less");

.topBar {
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;

  background: rgba(85, 84, 84, 0.304);
  z-index: 2000;
  transition: all 0.3s;
  border-bottom: 2px solid rgba(162, 158, 158, 0.162);

  &_left {
    position: absolute;
    left: 0;
    top: 20%;

    img {
      width: 25%;
    }
  }
  &_right {
    width: 700px;
    height: 100%;
    position: absolute;
    right: 20%;
    .fixcenter();

    p {
      width: 15%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      cursor: default;
    }

    .transitionBar {
      width: 100px;
      height: 5px;
      background: #fff;
      position: absolute;
      bottom: 5px;
      left: 196px;
      border-radius: 1vw;
    }
  }
}

.mobileBar {
  width: 100%;
  height: 50px;
  background: rgb(255, 255, 255);
  display: none;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 2000;

  p {
    display: flex;
    justify-content: center;
    align-items: center;

    &:nth-child(1) {
      width: 150px;
      height: 100%;

      img {
        width: 90%;
      }
    }

    &:nth-child(2) {
      width: 50px;
      height: 100%;

      img {
        width: 60%;
      }
    }
  }

  ul {
    width: 100%;
    height: 0;
    position: absolute;
    top: 100%;
    overflow: hidden;

    li {
      width: 100%;
      height: 50px;
      transition: all 0.3s;
      background: rgb(255, 255, 255);
      border-bottom: 1px solid #dfdcdc63;
      display: flex;
      align-items: center;
      justify-content: start;
      box-sizing: border-box;
      padding: 20px;

      &:last-child {
        border: none;
      }
    }
  }
}

@media (max-width: 550px) {
  .topBar {
    display: none;
  }
  .mobileBar {
    display: flex;
  }
}
</style>
